<template>
    <div class="hello">
        <div class="home" :style="windowWidth < 1441?'width: calc(100% - 40px);':'width: calc(1440px - 40px);'">
            <div class="home_top">
                友情链接： 
                <div style="width: 100%;display: flex;flex-wrap: wrap;align-items: center;margin: 20px 0;">
                    <div class="home_top_link" style="margin-right: 30px;cursor: pointer;" v-for="item,index in linkList" :key="index" @click="linkClick(item)">{{ item.name }}</div>
                </div>
            </div>
            <div class="main_box">
                <div class="main_left">
                    <img class="mian_img" src="@/assets/home/icon3.png" alt="">
                    <div>{{ message.referral }}</div>
                </div>
                <div class="main_nav" v-for="item,index in bottomList" :key="index">
                    <div class="main_title">{{ item.menu_name }}</div>
                    <div style="margin-bottom: 16px;cursor: pointer;" v-for="i,j in item.children" :key="j" @click="menuClick(i)">{{ i.menu_name }}</div>
                </div>
                <div class="main_nav" style="align-items: flex-start;margin-right: 80px;">
                    <div class="main_title">联系我们</div>
                    <div class="main_item">
                        <img class="main_item_img" src="@/assets/home/img1.png" alt="">
                        客服热线: {{ message.phone }}
                    </div>
                    <div class="main_item">
                        <img class="main_item_img" src="@/assets/home/img2.png" alt="">
                        邮箱: {{ message.email }}
                    </div>
                    <div class="main_item">
                        <img class="main_item_img" src="@/assets/home/img3.png" alt="">
                        地址: {{ message.address }}
                    </div>
                    <div class="main_item">
                        <img class="main_item_img" src="@/assets/home/img4.png" alt="">
                        工作时间: {{ message.time }}
                    </div>
                    <div class="main_item" style="margin-top: 20px;margin-left: 6px;">
                        <img style="width: 90px;object-fit: contain;" :src="message.code" alt="">
                        <div style="margin-left: 20px;font-size: 14px;color: #999999;">扫码关注公众号</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot_box">{{ message.provider }}</div>
    </div>
</template>

<script>
import {
    getLink,
    getConfigdata,
    getBottommenu
} from "@/api/api";
export default {
    name: "FootIndex",
    props: {
        msg: String,
    },
    data() {
        return {
            windowWidth: window.innerWidth,
            linkList: [],
            url: 'http://api.7heal.cn/uploads',
            message: {
                phone: null,
                email: null,
                address: null,
                time: null,
                code: null,
                referral: null,
            },
            bottomList: [],
        };
    },
    watch: {
        windowWidth() {
            this.windowWidth = window.innerWidth;
        },
    },
    mounted() {
        const that = this
		that.fullClick()
        that.getLists()
		window.addEventListener('resize', that.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        getLists() {
            getLink().then(res => {
                if (res.code === 0) {
                    this.linkList = res.data;
                }
            });
            getConfigdata({
                configId: 1
            }).then(res => {
                if (res.code === 0) {
                    res.data.map(item => {
                        if(item.code == 'site_record_icp'){
                            this.message.provider = item.value;
                        }
                        if(item.code == 'customer'){
                            this.message.phone = item.value;
                        }
                        if(item.code == 'site_email'){
                            this.message.email = item.value;
                        }
                        if(item.code == 'site_address'){
                            this.message.address = item.value;
                        }
                        if(item.code == 'working_hours'){
                            this.message.time = item.value;
                        }
                        if(item.code == 'wechat_code'){
                            this.message.code = item.value;
                        }
                        if(item.code == 'site_desc'){
                            this.message.referral = item.value;
                        }
                    })
                }
            });
            getBottommenu().then(res => {
                if (res.code === 0) {
                    this.bottomList = res.data
                }
            });
        },
        linkClick(item) {
            if(item.url&&item.url != ''){
                window.open(item.url);
            }
        },
        menuClick(item) {
            if(item.menu_path&&item.menu_path != ''){
                window.open(item.menu_path);
            }
        },
        skipTo(e) {
            this.$router.push(e);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        fullClick(){
			if(this.windowWidth<751){
				window.location.reload();
			}
		},
    },
};
</script>

<style scoped lang="less">
.hello {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F7F8FA;

    .home {
        display: flex;
        flex-direction: column;
        margin: 0 20px;

        .home_top {
            width: 100%;
            border-bottom: 2px solid #E0E0E0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            padding-top: 20px;
            margin-bottom: 40px;

            .home_top_link {
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #00B1AE;
                display: flex;
                align-items: center;
                margin-bottom: 12px;
            }
        }
        .main_box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 50px;

            .main_left {
                width: 28%;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 22px;

                .mian_img {
                    width: 110px;
                    object-fit: cover;
                    margin-bottom: 26px;
                }
            }

            .main_nav {
                display: flex;
                flex-direction: column;
                align-items: center;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 16px;
                color: #666666;

                .main_title {
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    font-size: 18px;
                    color: #333333;
                    margin-bottom: 30px;
                    cursor: pointer;
                }
                .main_item {
                    display: flex;
                    align-items: center;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    font-size: 16px;
                    color: #666666;
                    margin-bottom: 16px;

                    .main_item_img {
                        width: 17px;
                        height: 18px;
                        object-fit: contain;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
.foot_box {
    width: 100%;
    height: 60px;
    background: #F7F8FA;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    border-top: 2px solid #f4f4f4;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
